import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_am2enhr6ay: FaireBrandEntity = {
  token: "b_am2enhr6ay",
  type: "brand",
  name: "Slow Day Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb3e965508e75374b590b121db4d522730df45af3be67ae2196a80514ca9e65f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dbe31a1717d18433ccce5f6186c3fae723ed467ff6aacc9b22b0772be7063775.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb3e965508e75374b590b121db4d522730df45af3be67ae2196a80514ca9e65f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dbe31a1717d18433ccce5f6186c3fae723ed467ff6aacc9b22b0772be7063775.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 20,
  isInsider: false,
  description:
    'CASEY FOUNDED SLOW DAY STUDIOS IN APRIL 2020 AS A WAY TO NOURISH HER CREATIVE SOUL AND TO GIVE BACK IN A TIME OF NEED.\n\n"I CREATED SLOW DAY STUDIOS WHEN THE WORLD SEEMED BLEAK, THE COVID 19 PANDEMIC HAD JUST BEGUN AND I FELT WE ALL NEEDED A LITTLE BIT OF A HOT PINK MOMENT IN OUR LIVES. MY PIECES ARE MEANT TO REFLECT THAT EVERYDAY, LIGHTWEIGHT JEWELRY CAN BE BIG, BOLD + FUN."\n\nOUR PIECES ARE HEAVILY INSPIRED BY BEAUTIFUL FLORALS, FUN ILLUSTRATIVE STYLES, AND BRIGHT COLOURS. HOT PINK IS CONSIDERED A NEUTRAL FOR US!\n\nOUR MISSION AT SLOW DAY STUDIOS IS TO CREATE HANDMADE, UNIQUE + COLOURFUL PIECES THAT SHOWCASE YOUR PERSONALITY, WHILE HELPING OUR COMMUNITY IN A LONG LASTING WAY.\n\nENDING THE STIGMA SURROUNDING MENTAL HEALTH IS SOMETHING WE FEEL STRONGLY ABOUT WHICH IS WHY 5% OF ALL SALES ARE DONATED TO LOCAL MENTAL HEALTH INITIATIVES WITHIN THE GREATER TORONTO AREA.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.595Z",
    importedBy: "entity-db-cli",
  },
};
